/** Togglers in header */
;(() => {
	const headerDOM = document.querySelector('.js-site-header')
	const bodyDOM = document.querySelector('body')
	const burgerDOM = document.querySelector('.js-burger-menu')
	window.menuToggler = function(){
		headerDOM.classList.toggle('is-menu-toggled')
		burgerDOM.classList.toggle('is-active')
		bodyDOM.classList.toggle('overflow-hidden')
	}
})();

;(() => {
	window.changeListItem = function(list, index){
		const listItems = document.querySelectorAll(list)
		listItems.forEach(x => x.classList.remove('is-active'))
		listItems[index].classList.add('is-active')
	}
})();

(() => {
	const buildingNavDOM = document.querySelectorAll('.js-building-nav');
	const buildingsDOM = document.querySelectorAll('.js-building');
	const buildingMainDOM = document.querySelector('.js-building-main');
	const buildingReturnDOM = document.querySelector('.js-building-return');
	function hashChangeHandler(){
		const hash = location.hash;
		const hashNumber = hash.replace( /^\D+/g, '')

		console.log('HASH', hash, hashNumber)

		if(hash.includes('b')){
			buildingMainDOM.classList.add('hidden')
			buildingsDOM.forEach(x => x.classList.add('hidden'))
			buildingsDOM[hashNumber - 1].classList.remove('hidden')
			buildingReturnDOM.classList.remove('translate-y-32')
		}else if(hash.includes('p')){
			// buildingMainDOM.classList.add('hidden')
			// buildingsDOM.forEach(x => x.classList.add('hidden'))
			// buildingsDOM[hashNumber - 1].classList.remove('hidden')
			// buildingReturnDOM.classList.remove('translate-y-32')
		}else{
			if(hash == "#return" || hash == ""){
				console.log("TUTAJ2")
				buildingsDOM.forEach(x => x.classList.add('hidden'))
				buildingMainDOM.classList.remove('hidden')
				buildingReturnDOM.classList.add('translate-y-32')
			}
		}
	}

	if(buildingsDOM && buildingMainDOM){
		hashChangeHandler()

		window.addEventListener('hashchange', function(){
			hashChangeHandler()
		})
	}
})()




const imageAreas = document.querySelectorAll(".js-image-map area");
if (imageAreas) {
	const imageText = document.querySelector(".js-image-map-text");

	document.onmousemove = handleMouseMove;
	function handleMouseMove(event) {
		try {
			var eventDoc, doc, body;
			event = event || window.event;
			if (event.pageX == null && event.clientX != null) {
				eventDoc = (event.target && event.target.ownerDocument) || document;
				doc = eventDoc.documentElement;
				body = eventDoc.body;
				event.pageX =
					event.clientX +
					((doc && doc.scrollLeft) || (body && body.scrollLeft) || 0) -
					((doc && doc.clientLeft) || (body && body.clientLeft) || 0);
				event.pageY =
					event.clientY +
					((doc && doc.scrollTop) || (body && body.scrollTop) || 0) -
					((doc && doc.clientTop) || (body && body.clientTop) || 0);
			}

			imageText.style.top = event.pageY - imageText.clientHeight + "px";
			imageText.style.left = event.pageX + "px";
		} catch (e) {}
	}
}


;(() => {
	const navsDOM = document.querySelectorAll('.js-rent-sell-form-nav')
	const formDOM = document.querySelector('.js-rent-sell-form')
	window.changeRentSellForm = (el, type) => {
		navsDOM.forEach(x => {
			x.classList.remove('bg-primary')
			x.classList.add('overflow-hidden')
			x.classList.add('text-quaternary')
			x.classList.add('bg-quinary')
		})

		el.classList.add('bg-primary')
		el.classList.add('text-white')
		el.classList.remove('overflow-hidden')
		el.classList.remove('text-quaternary')
		el.classList.remove('bg-quinary')
		
		formDOM.querySelector('[name="category"]').value = type
	}
})();

(() => {
	const playButton = document.querySelector('.js-video-play');
	if(playButton){
		const video = playButton.parentNode.querySelector('video');
		playButton.addEventListener('click', () => {
			video.play();
		})

		video.addEventListener('play', () => {
			video.classList.remove('opacity-50');
			playButton.classList.add('pointer-events-none');
			playButton.classList.add('opacity-0');
		})
	}
})();